import G6 from '@antv/g6';
import { colors } from 'ui/theme';
import { ItemState } from '../../constants';
import { deleteStyles, deleteStylesActive } from '../constants';

const COLOR_DEFAULT = colors.grey50;
const COLOR_SELECTED = colors.purple90;
const COLOR_HOVER = colors.purple50;

const edgeSelectedStyle = {
  stroke: COLOR_SELECTED,
  lineWidth: 3,
  cursor: 'pointer',
};

const edgeBaseStyle = {
  stroke: COLOR_DEFAULT,
  lineWidth: 2,
  // Region which acts to mouse events.  Makes hit target bigger.
  lineAppendWidth: 10,
  shadowColor: undefined,
  shadowBlur: 0,
  radius: 16,
  offset: 25,
  startArrow: {
    path: G6.Arrow.circle(2, -1),
    fill: COLOR_DEFAULT,
  },
  endArrow: {
    path: 'M 0,0 L 4,3 L 4,-3 Z',
  },
};

export const edgeConfigOptions = {
  style: edgeBaseStyle,
  ...deleteStyles,
};

export const edgeStateStyles = {
  [ItemState.Selected]: edgeSelectedStyle,
  // edges leading to selected node
  [ItemState.HighLight]: edgeSelectedStyle,
  // hover
  [ItemState.Active]: {
    stroke: COLOR_HOVER,
    cursor: 'pointer',
    ...deleteStylesActive,
  },
};
